import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Dashboard from "./pages/dashboard/Dashboard";
import DashboardHome from "./pages/dashboard/DashboardHome";
import DashboardChat from "./pages/dashboard/DashboardChat";
import VisionBoard from "./pages/dashboard/VisionBoard";
import GratitudePractice from "./pages/dashboard/GratitudePractice";
import DashboardMindfulChat from "./pages/dashboard/DashboardMindfulChat";
import PairDevice from "./pages/dashboard/PairDevice";
import NotFound from "./pages/NotFound";
import Subscription from "./pages/Subscription";
import SpotifyCallback from "./pages/SpotifyCallback";
import RequireAuth from "./components/RequireAuth";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/spotify/callback" element={<RequireAuth><SpotifyCallback /></RequireAuth>} />
          <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>}>
            <Route index element={<DashboardHome />} />
            <Route path="chat" element={<DashboardChat />} />
            <Route path="vision-board" element={<VisionBoard />} />
            <Route path="gratitude" element={<GratitudePractice />} />
            <Route path="mindful-chat" element={<DashboardMindfulChat />} />
            <Route path="pair-device" element={<PairDevice />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
